import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(pages)/(app)/wallet/page.tsx");
